//配置全局访问接口地址
// let commonUrl = "https://admin.rogtazg.com/";
 let commonUrl = window.config.domain;

let baseUrl = {
    commonUrl
}

export default baseUrl

